










































































import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import hexabaseState from '@/store/hexabase';
import userState from '@/store/user';

// External variables
import {
  materialTemplateOptionalForm,
  materialTemplateRegisterHeader
} from '@/constants/form/materialTemplateForm';
import {
  PartsListHeaders,
  editFinishText,
  editFinishAction,
  MaterialTemplateListDisplayButtonDisabledItems,
  MaterialtemplateListDisplayInputFormatItemsPartsList,
  ExceptionHeaderItem,
  MaterialTemplateListDisplayButtonItems
} from '@/constants/materialtemplate/materialtemplate';
import {
  FieldChildrenProp,
  ActionFieldSeeting,
  StatusActions,
  ItemActions,
  ActionButtons,
  StatusList,
  FieldsInfo,
  HexaFileFieldResponse
} from '@/services/hexabase/types';

// Model
import MaterialTemplate from '@/models/materialTemplateModel';

import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import ActionButtonPanel from '@/components/common/modules/ActionButtonPanel.vue';
import CreateBasicInfo from '@/components/sample/detail/CreateBasicInfo.vue';
import TransitionDialog from '@/components/common/modules/TransitionDialog.vue';
import ExecAction from '@/components/common/modules/ExecAction.vue';
import IconTextLink from '@/components/common/elements/IconTextLink.vue';
import HeaderPanel from '@/components/common/modules/HeaderPanel.vue';
import ListDisplay from '@/components/common/modules/ListDisplay.vue';

interface Rules {
  id: string;
  rule: string[];
  referenceField?: {
    id: string;
    rule: string;
  }[];
}
interface FieldValues {
  field_id: string;
  field_name: string;
  dataType: string;
  value: string;
  sizeX: number;
  sizeY: number;
  col: number;
  row: number;
}
interface SelectOptions {
  option_id: string;
  sort_id: 0;
  value: string;
  enabled: true;
  color: string;
  display_id: string;
  text: string;
}
/** リスト用 */
interface RegistMaterialTempleteData {
  No: number;
  id: number;
  quantity: number;
  quantity_lower_limit?: number;
  quantity_upper_limit?: number;
  unit_lower_limit?: number;
  unit_upper_limit?: number;
  refitem: string;
  refitem_code: string;
  refmodel_number: string;
  refrev_no: number;
  material_id: string;
  rev_no: number;
  i_id: string;
  edit_price_flag?: string;
  edit_material_flag?: string;
}
/** 登録用 */
interface RegistMaterialTempleteExec {
  /** 参照元基本のID */
  materialtemplate_id: string;
  /** 数量 */
  quantity: number;
  /** 参照品名 */
  ref_item: string;
  /** 参照品番 */
  ref_item_code: string;
  /** 参照型番 */
  ref_model_number: string;
  /** 参照リビジョン */
  ref_rev_no: number;
  /** 参照元構成表マスタ */
  material_id: string;
  /** 参照元構成表マスタ */
  sort_no: number;
  edit_price_flag?: string;
  edit_material_flag?: string;
  /** 数量 下限、上限 */
  quantity_lower_limit?: number;
  quantity_upper_limit?: number;
  /** 単価 下限、上限 */
  unit_lower_limit?: number;
  unit_upper_limit?: number;
}
interface PartsListDataformat {
  No: number;
  id: number;
  quantity: number;
  quantity_lower_limit?: number;
  quantity_upper_limit?: number;
  item: string;
  item_code: string;
  model_number: string;
  standard_unit_price: number;
  unit_lower_limit?: number;
  unit_upper_limit?: number;
  classification_id: string;
  type_id: string;
  commodity_id: string;
  refrev_no: number;
  transfer_unit_price: number;
  material_id: string;
  rev_no: number;
  materialtemplate_id: string;
  i_id: string;
  edit_price_flag?: string;
  edit_material_flag?: string;
}
Component.registerHooks(['beforeRouteEnter']);
@Component({
  components: {
    Header,
    SideMenu,
    PageInfoBar,
    ActionButtonPanel,
    CreateBasicInfo,
    TransitionDialog,
    HeaderPanel,
    ExecAction,
    IconTextLink,
    ListDisplay
  },
  beforeRouteEnter(to: Route, from: Route, next: any): void {
    next((vm: any) => {
      vm.prevRoute = from;
      next();
    });
  },
  beforeRouteUpdate(to, from, next) {
    // URL変更前
    next();
    // URL変更後
    // URL変更のタイミングで再描画する
    if (to.path !== from.path) {
      this.$router.go(0);
    }
  }
})
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
export default class MaterialTemplateEdit extends Vue {
  private projectId = hexabaseState.applicationId;
  private materialTemplate = new MaterialTemplate();
  private headerData = { cols: {}, datas: {} as { [k: string]: any } };

  // 各入力フィールド情報格納プロパティ
  private basicFieldsData: Array<FieldChildrenProp> = [];
  private basicFieldCols = '';

  // dbID格納プロパティ
  private mainDsId = '';
  private subDsId = '';

  // 登録用情報格納プロパティ
  private registData: any = {
    item: {},
    return_item_result: true, // true指定すると、登録されたアイテム情報を返します
    related_ds_items: {} // 関連するデータストアの新規・更新・削除を指定  詳細は以下を参照
  };
  private registFieldType: any = {};

  // 初期ステータス
  private displayStatus = '';

  // 編集対象アイテム情報
  private itemId = this.$route.params.id;
  private refCommodityId = '';
  private revNumber = 0;
  private currentData: Array<FieldsInfo> = [];

  // アクション情報格納プロパティ
  private statusButton: Array<StatusActions> = [];
  private statusAction: Array<StatusActions> = [];
  private itemActions: Array<ItemActions> = [];
  private execAllowActions: Array<ActionButtons> = [];
  private execAllowActionsByDetail: Array<ActionButtons> = [];
  private selectAction = '';

  // ステータス情報格納プロパティ
  private statusList: Array<StatusList> = [];
  private buttonCrudType = '';
  private buttonActionName = '';

  // アイテム登録後ダイアログ
  private dialogStatus = false;
  private isLoading = false;
  private buttonText = this.materialTemplate.deepCopy(editFinishText);
  private buttons: Array<{ [k: string]: string | number }> = this.materialTemplate.deepCopy(
    editFinishAction
  );

  private partsListColumn: any = [];
  private partsListData: any = [];

  private partsList = {
    listName: '部品一覧',
    formOutputButtonName: '',
    isAddItemButtonFlag: false,
    tableParameters: {
      isDisabledFormOutputButton: false,
      isDisabledNoteEdit: true,
      buttonItems: MaterialTemplateListDisplayButtonDisabledItems,
      inputItems: [],
      columns: this.partsListColumn,
      body: this.partsListData,
      tableText: '商材が選択されていません'
    },
    subHeadersScrollWidthData: 0
  };

  private exceptionHeaderItem = ExceptionHeaderItem;

  // マスタデータ関連格納プロパティ
  private masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};

  /** リスト */
  private RegistMaterialTempleteDataList: Array<RegistMaterialTempleteData> = [];
  private DeleteMaterialTempleteDataList: Array<RegistMaterialTempleteData> = [];

  async created() {
    try {
      // ローディングをセット
      this.$store.commit('hexabase/setIsLoading', true);

      // 管理者権限判定
      if (!userState.isAdmin) {
        this.setError(this.materialTemplate.getDefaultRoleErrorMessage());
        return;
      }

      this.mainDsId = hexabaseState.datastoreIds['構成表テンプレート'];
      this.subDsId = hexabaseState.datastoreIds['構成表テンプレート明細'];

      // 既存アイテムを取得しアイテム情報・アクション情報を保持
      const [basicResult, myFieldsData] = await Promise.all([
        this.materialTemplate.getLinkedItems(
          hexabaseState.applicationId,
          this.mainDsId,
          this.itemId,
          'format'
        ),
        this.materialTemplate.getFieldsData(this.projectId, this.subDsId).then(response => {
          this.setHeaderListColumn(
            response,
            PartsListHeaders,
            this.partsList.tableParameters,
            'columns',
            this.exceptionHeaderItem
          );
        })
      ]);

      const commodityData: any = basicResult.linked_items.m_commodity.items[0];
      this.refCommodityId = commodityData.i_id || '';
      const materialTemplateData: any = basicResult.linked_items.m_materialtemplate_detail;
      // 削除済みのデータは操作させない
      const wkdata1: FieldValues = basicResult.field_values.Status;
      const wkStList: Array<StatusList> = [];
      Object.keys(basicResult['status_list']).forEach(v => {
        wkStList.push(basicResult.status_list[v]);
        this.statusList.push(basicResult.status_list[v]);
      });
      const wkStatus = wkStList.find(v => v.status_id === (wkdata1.value || ''))?.status_name;
      this.displayStatus = wkStatus === '有効' ? '' : wkStatus || '';

      // eslint-disable-next-line prefer-const
      let wkStatusAction: Array<StatusActions> = [];
      if (this.materialTemplate.isNullOrUndefined(basicResult.status_actions)) {
        Object.keys(basicResult['status_actions']).forEach(v => {
          const wkStAc: StatusActions = basicResult.status_actions[v];
          wkStatusAction.push(wkStAc);
        });
      }
      const wkStatusAction2 = wkStatusAction.sort(function(a, b) {
        return (a.display_order || 0) - (b.display_order || 0);
      });
      wkStatusAction2.forEach(v => {
        this.statusAction.push(v);
      });

      // eslint-disable-next-line prefer-const
      let wkItemActions: Array<ItemActions> = [];
      if (this.materialTemplate.isNullOrUndefined(basicResult.item_actions)) {
        Object.keys(basicResult['item_actions']).forEach(v => {
          const wkItAc: ItemActions = basicResult.item_actions[v];
          wkItemActions.push(wkItAc);
        });
      }
      const wkItemActions2 = wkItemActions.sort(function(a, b) {
        return (a.display_order || 0) - (b.display_order || 0);
      });
      wkItemActions2.forEach(v => {
        this.itemActions.push(v);
      });

      // ステータス移管に使用するためリビジョン番号を格納
      this.revNumber = basicResult.rev_no;
      // DB登録用データを作成
      Object.keys(basicResult['field_values']).forEach(v => {
        this.currentData.push(basicResult.field_values[v]);
      });

      for (const key in this.currentData) {
        if (this.currentData[key].value !== undefined && this.currentData[key].value !== null) {
          let value = this.currentData[key].value;
          if (
            this.currentData[key].dataType === 'dslookup' &&
            typeof this.currentData[key].value === 'object' &&
            this.currentData[key].value !== null &&
            this.currentData[key].value.item_id !== undefined
          ) {
            value = this.currentData[key].value.item_id;
          }
          if (this.currentData[key].dataType === 'file') {
            value =
              this.currentData[key].value.length === 0
                ? []
                : (this.currentData[key].value as HexaFileFieldResponse[])
                    .map(file => file.file_id)
                    .filter(v => v);
          }

          this.registData.item[this.currentData[key].field_id] = value;
        }
      }

      await this.getBasicFields();
      this.headerData = await this.getHeaderFields(materialTemplateRegisterHeader);
      const cheaderData = {
        0: commodityData.lookup_items.service_type_id.service_type || '',
        1: commodityData.commodity || '',
        2: commodityData.lookup_items.supplier_id.supplier || ''
      } as { [key: string]: any };
      // Get&set header data
      this.getHeaderData(cheaderData, this.headerData);

      // eslint-disable-next-line prefer-const
      let baseItemsList: Array<PartsListDataformat> = [];
      for (let index = 0; index < materialTemplateData.items.length; index++) {
        const materialTemplateElement = materialTemplateData.items[index];
        const baseItems: PartsListDataformat = {
          No: Number(materialTemplateElement['sort_no'] || '0'),
          id: Number(materialTemplateElement['id'] || '0'),
          quantity: Number(materialTemplateElement['quantity'] || '0'),
          quantity_lower_limit: Number(materialTemplateElement['quantity_lower_limit'] || '0'),
          quantity_upper_limit: Number(materialTemplateElement['quantity_upper_limit'] || '0'),
          item: materialTemplateElement['ref_item'],
          item_code: materialTemplateElement['ref_item_code'],
          model_number: materialTemplateElement['ref_model_number'],
          standard_unit_price: 0,
          unit_lower_limit: Number(materialTemplateElement['unit_lower_limit'] || '0'),
          unit_upper_limit: Number(materialTemplateElement['unit_upper_limit'] || '0'),
          classification_id: '',
          type_id: '',
          commodity_id: this.refCommodityId,
          refrev_no: Number(materialTemplateElement['ref_rev_no'] || '0'),
          transfer_unit_price: 0,
          material_id:
            materialTemplateElement.lookup_items.material_id !== undefined
              ? materialTemplateElement.lookup_items.material_id['i_id']
              : '',
          rev_no: Number(materialTemplateElement['rev_no'] || '0'),
          materialtemplate_id: this.itemId,
          edit_price_flag: materialTemplateElement.edit_price_flag === 'false'
              ? materialTemplateElement.edit_price_flag
              : '',
          edit_material_flag: materialTemplateElement.edit_material_flag === 'false'
              ? materialTemplateElement.edit_material_flag
              : '',
          i_id: materialTemplateElement['i_id']
        };
        baseItemsList.push(baseItems);
      }
      //セットする前に補完を行う
      // eslint-disable-next-line prefer-const
      let resetItemsList: any = [];
      let isMatchList = true;
      if (
        this.masterData['m_material'] !== undefined &&
        this.masterData['m_material'].body !== undefined &&
        this.masterData['m_material'].body.length > 0
      ) {
        const materialData: Array<{ [k: string]: string }> = this.masterData['m_material'].body;
        for (let index = 0; index < materialData.length; index++) {
          const materialElement = materialData[index];
          const comparisonIndex = baseItemsList.findIndex(
            v => v.material_id === materialElement['i_id']
          );
          if (
            isMatchList === true &&
            comparisonIndex !== undefined &&
            comparisonIndex >= 0 &&
            baseItemsList[comparisonIndex].refrev_no === Number(materialElement['rev_no'] || '0')
          ) {
            //
            baseItemsList[comparisonIndex].transfer_unit_price = Number(
              materialElement['transfer_unit_price'] || '0'
            );
            baseItemsList[comparisonIndex].standard_unit_price = Number(
              materialElement['standard_unit_price'] || '0'
            );
            baseItemsList[comparisonIndex].classification_id = materialElement['classification_id'];
            baseItemsList[comparisonIndex].type_id = materialElement['type_id'];
          } else {
            isMatchList = false;
          }
          const baseItems: any = {};
          const tepNo = Number(index) + 1;
          this.$set(baseItems, 'No', tepNo);
          this.$set(baseItems, 'id', Number(index));
          this.$set(baseItems, 'quantity', 0);
          this.$set(baseItems, 'item', materialElement['item']);
          this.$set(baseItems, 'item_code', materialElement['item_code']);
          this.$set(baseItems, 'model_number', materialElement['model_number']);
          this.$set(baseItems, 'standard_unit_price', materialElement['standard_unit_price']);
          this.$set(baseItems, 'classification_id', materialElement['classification_id']);
          this.$set(baseItems, 'type_id', materialElement['type_id']);
          this.$set(baseItems, 'commodity_id', materialElement['commodity_id']);
          this.$set(baseItems, 'refrev_no', materialElement['rev_no']);
          this.$set(baseItems, 'transfer_unit_price', materialElement['transfer_unit_price']);
          this.$set(baseItems, 'material_id', materialElement['i_id']);
          this.$set(baseItems, 'i_id', '');
          resetItemsList.push(baseItems);
        }
      }

      const setlist: any =
        isMatchList === true
          ? baseItemsList.sort(function(a, b) {
              return (a.No || 0) - (b.No || 0);
            })
          : resetItemsList;

      for (let index = 0; index < setlist.length; index++) {
        const element2 = setlist[index];
        this.partsListData.push(element2);
        // 登録用データの初期化
        const registItemsList: RegistMaterialTempleteData = {
          No: element2.No,
          id: element2.id,
          quantity: element2.quantity,
          quantity_lower_limit: element2.quantity_lower_limit,
          quantity_upper_limit: element2.quantity_upper_limit,
          unit_lower_limit: element2.unit_lower_limit,
          unit_upper_limit: element2.unit_upper_limit,
          refitem: element2.item,
          refitem_code: element2.item_code,
          refmodel_number: element2.model_number,
          refrev_no: element2.refrev_no,
          material_id: element2.material_id,
          rev_no: element2.rev_no,
          i_id: element2.i_id,
          edit_price_flag: element2.edit_price_flag === 'false' ? 'false' : 'true',
          edit_material_flag: element2.edit_material_flag === 'false' ? 'false' : 'true'
        };
        this.RegistMaterialTempleteDataList.push(registItemsList);
      }
      //アンマッチ時に既存の明細データを削除するための情報
      if (isMatchList !== true) {
        for (let index = 0; index < baseItemsList.length; index++) {
          const element3 = baseItemsList[index];
          // 削除用データの初期化
          const DeleteItemsList: RegistMaterialTempleteData = {
            No: element3.No,
            id: element3.id,
            quantity: 0,
            quantity_lower_limit: 0,
            quantity_upper_limit: 0,
            unit_lower_limit: 0,
            unit_upper_limit: 0,
            refitem: element3.item,
            refitem_code: element3.item_code,
            refmodel_number: element3.model_number,
            refrev_no: 0,
            material_id: '',
            rev_no: element3.rev_no,
            i_id: element3.i_id,
            edit_price_flag: element3.edit_price_flag === 'false' ? 'false' : 'true',
            edit_material_flag: element3.edit_material_flag === 'false' ? 'false' : 'true'
          };
          this.DeleteMaterialTempleteDataList.push(DeleteItemsList);
        }
      }

      this.execAllowActions = this.statusAction as Array<ActionButtons>;
      this.statusButton = this.materialTemplate.statusButtonList(
        this.execAllowActions,
        this.currentData
      );
    } catch (e) {
      if (e instanceof Error) {
        console.log(e.message);
        this.setError(e.message);
      } else if (typeof e === 'string') {
        console.log(e);
        this.setError(e);
      }
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  /**
   * 基本情報入力フォームを生成するための設定情報を取得・整形します
   */
  private async getBasicFields() {
    try {
      const initialAction = this.materialTemplate.getFormDisplayAction(
        this.itemActions,
        'UpdateItem'
      );
      const [inputFields, fieldsData] = await Promise.all([
        this.materialTemplate.getFieldsByActionId(this.mainDsId, initialAction!.action_id),
        this.materialTemplate.makeFieldsList(this.projectId, this.mainDsId, this.currentData),
        this.materialTemplate.getMasterData('', this.refCommodityId)
      ]);
      this.masterData = this.materialTemplate.getMaster();
      // データ登録時の為各フィールドのデータ型を格納
      for (const key in inputFields.action_fields) {
        this.registFieldType[inputFields.action_fields[key].display_id] =
          inputFields.action_fields[key].dataType;
      }
      const data = this.materialTemplate
        .addOptionalFormField(
          fieldsData.filter(v => v.dataType !== 'status'),
          this.materialTemplate.deepCopy(materialTemplateOptionalForm)
        )
        .map(field => this.materialTemplate.inputRestriction(field, inputFields))
        .map(field => this.materialTemplate.setSelectAreaItemId(field))
        .map(field => this.materialTemplate.setPropsByLocalProperty(field, this))
        .map(field => {
          if (field.dataType === 'dslookup') {
            field.props!.isBtnVisible = false;
          }
          field.props!.isReadonly = true;
          field.props!.isDisabled = true;
          return field;
        });

      // // ID値を退避
      // await this.setReferenceArea(fieldsData, fieldsData2);

      // フォーカス調整のため要素を並べ替え
      // const sortwk1 = data.sort(function(a, b) {
      //   return (a.col || 0) - (b.col || 0);
      // });
      // const sortwk2 = sortwk1.sort(function(a, b) {
      //   return (a.row || 0) - (b.row || 0);
      // });
      this.basicFieldCols = this.materialTemplate.getGridStatus(data);
      this.basicFieldsData = data;
    } catch (error) {
      if (error instanceof Error) {
        console.log(error.message);
        this.setError(error.message);
      } else if (typeof error === 'string') {
        console.log(error);
        this.setError(error);
      }
    }
  }

  /**
   * アクションパネルのボタンを押下した際の次処理を進める
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private async buttonAction(type: any) {
    try {
      // 全要素ReadOnlyアクションか判定
      const targetButton = this.statusButton.find(v => v.display_id === type);
      this.buttonCrudType = targetButton!.crud_type;
      this.buttonActionName = targetButton!.action_name;
      // ローディングをセット
      this.$store.commit('hexabase/setIsLoading', true);
      // アクション毎の見出し要素入力制限反映 MaterialtemplateListDisplayInputFormatItemsPartsList
      const copy = this.materialTemplate.modifyButtonProp(this.execAllowActions, type);
      if (copy !== undefined && copy.length > 0) {
        this.execAllowActions.splice(0, copy.length, ...copy);
      }
      const execAction = this.execAllowActions.find(action => action.display_id === type);
      if (execAction !== undefined) {
        this.selectAction = execAction.display_id;
        // ToDo 自動生成を使用する場合
        const result = (await this.modifyFields(
          this.mainDsId,
          this.basicFieldsData,
          execAction
        )) as Array<FieldChildrenProp>;
        this.basicFieldsData = result;
      }
      if (this.selectAction === 'mtempbase_valid_update') {
        this.$set(
          this.partsList.tableParameters,
          'inputItems',
          MaterialtemplateListDisplayInputFormatItemsPartsList
        );
        this.$set(
          this.partsList.tableParameters,
          'buttonItems',
          MaterialTemplateListDisplayButtonItems
        );
      }
    } catch (error) {
      let errorMessage = 'Failed to do something exceptional';
      if (error instanceof Error) {
        errorMessage = error.message;
      }
      this.setError(errorMessage);
    } finally {
      this.statusButton = [
        ...this.materialTemplate.statusButtonList(this.execAllowActions, this.currentData, type)
      ];
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  async modifyFields(
    dbId: string,
    data: Array<FieldChildrenProp> | Array<FieldChildrenProp[]>,
    execAction: ActionButtons
  ) {
    const inputFields = await this.materialTemplate
      .getFieldsByActionId(dbId, execAction.action_id)
      .then(data => {
        return data;
      });

    data = this.addInputRules(data as Array<FieldChildrenProp>, inputFields.action_field_settings);
    return this.modifyInputAllow(data, inputFields.action_field_settings) as Array<
      FieldChildrenProp
    >;
  }

  addInputRules(
    fields: Array<FieldChildrenProp>,
    fieldSetting: { [k: string]: ActionFieldSeeting }
  ) {
    return fields.map(field => {
      if (field.props === undefined) return field;

      const ruleArray = [];

      // Hexa側設定必須項目
      if (fieldSetting[field.field_id] !== undefined) {
        // 必須項目確認
        if (fieldSetting[field.field_id].mandatory) {
          const requiredName = field.component === 'SelectArea' ? 'selectRequired' : 'required';
          ruleArray.push(requiredName);
        }
      }

      if (field.props!['rules'] === undefined) {
        field.props!['rules'] = '';
      }
      if (ruleArray.length > 0) field.props!['rules'] = ruleArray.join('|');
      return field;
    });
  }

  modifyInputAllow(
    fields: Array<FieldChildrenProp>,
    fieldSetting: { [k: string]: ActionFieldSeeting }
  ) {
    return fields.map(field => {
      if (fieldSetting[field.field_id] !== undefined) {
        const row = fieldSetting[field.field_id];
        if (row.update) {
          field.props! = { ...field.props!, ...{ isDisabled: false, isReadonly: false } };
        }
        if (row.update && field.dataType === 'dslookup') {
          field.props!.isBtnVisible = true;
          field.props!.isLeftSideInputReadOnly = false;
        }
        field = {
          ...field,
          ...{
            show: row.show,
            update: row.update,
            mandatory: row.mandatory
          }
        };
      }
      return field;
    });
  }

  /**
   * 明細リスト更新時
   */
  private getDataRelay(response: any) {
    if (
      response['itemIndex'] !== undefined &&
      response['inputName'] !== undefined &&
      response['inputName'] === 'quantity' ||
      response['inputName'] === 'quantity_lower_limit' ||
      response['inputName'] === 'quantity_upper_limit' ||
      response['inputName'] === 'unit_lower_limit' ||
      response['inputName'] === 'unit_upper_limit' &&
      response['inputValue'] !== undefined
    ) {
      const chkId = Number(response.record.id || '-1');
      if (chkId >= 0) {
        //通常の更新パターン：レコード上のIDを使って列を引き当てる
        const findex: number = this.RegistMaterialTempleteDataList.findIndex(v => v.id === chkId);
        const Setquantity: number =
          response['inputValue'] !== '' ? Number(response['inputValue']) : 0;

        if (response['inputName'] === 'quantity') {
          if (findex !== -1) {
            this.$set(this.partsListData[response.itemIndex], 'quantity', Setquantity);
            this.$set(this.RegistMaterialTempleteDataList[findex], 'quantity', Setquantity);
          }
        }
        if (response['inputName'] === 'quantity_lower_limit') {
          if (findex !== -1) {
            this.$set(this.partsListData[response.itemIndex], 'quantity_lower_limit', Setquantity);
            this.$set(this.RegistMaterialTempleteDataList[findex], 'quantity_lower_limit', Setquantity);
          }
        }
        if (response['inputName'] === 'quantity_upper_limit') {
          if (findex !== -1) {
            this.$set(this.partsListData[response.itemIndex], 'quantity_upper_limit', Setquantity);
            this.$set(this.RegistMaterialTempleteDataList[findex], 'quantity_upper_limit', Setquantity);
          }
        }
        if (response['inputName'] === 'unit_lower_limit') {
          if (findex !== -1) {
            this.$set(this.partsListData[response.itemIndex], 'unit_lower_limit', Setquantity);
            this.$set(this.RegistMaterialTempleteDataList[findex], 'unit_lower_limit', Setquantity);
          }
        }
        if (response['inputName'] === 'unit_upper_limit') {
          if (findex !== -1) {
            this.$set(this.partsListData[response.itemIndex], 'unit_upper_limit', Setquantity);
            this.$set(this.RegistMaterialTempleteDataList[findex], 'unit_upper_limit', Setquantity);
          }
        }
      } else {
        //リセットが行われるとIDはすべて０埋されるので新規と同等に扱う
        const rindex: number = Number(response['itemIndex']) + 1;
        const findex: number = this.RegistMaterialTempleteDataList.findIndex(v => v.No === rindex);
        const Setquantity: number =
          response['inputValue'] !== '' ? Number(response['inputValue']) : 0;

        if (response['inputName'] === 'quantity') {
          if (findex !== -1) {
            this.$set(this.partsListData[response.itemIndex], 'quantity', Setquantity);
            this.$set(this.RegistMaterialTempleteDataList[findex], 'quantity', Setquantity);
          }
        }
        if (response['inputName'] === 'quantity_lower_limit') {
          if (findex !== -1) {
            this.$set(this.partsListData[response.itemIndex], 'quantity_lower_limit', Setquantity);
            this.$set(this.RegistMaterialTempleteDataList[findex], 'quantity_lower_limit', Setquantity);
          }
        }
        if (response['inputName'] === 'quantity_upper_limit') {
          if (findex !== -1) {
            this.$set(this.partsListData[response.itemIndex], 'quantity_upper_limit', Setquantity);
            this.$set(this.RegistMaterialTempleteDataList[findex], 'quantity_upper_limit', Setquantity);
          }
        }
        if (response['inputName'] === 'unit_lower_limit') {
          if (findex !== -1) {
            this.$set(this.partsListData[response.itemIndex], 'unit_lower_limit', Setquantity);
            this.$set(this.RegistMaterialTempleteDataList[findex], 'unit_lower_limit', Setquantity);
          }
        }
        if (response['inputName'] === 'unit_upper_limit') {
          if (findex !== -1) {
            this.$set(this.partsListData[response.itemIndex], 'unit_upper_limit', Setquantity);
            this.$set(this.RegistMaterialTempleteDataList[findex], 'unit_upper_limit', Setquantity);
          }
        }
      }
    }
  }

  private clickButton(response: any) {
    switch (response.buttonName) {
      case "edit_price_flag": {
        if (response.record.edit_price_flag !== '') {
          // 変更可
          this.$set(this.partsListData[response.itemIndex], 'edit_price_flag', '');
          this.$set(this.RegistMaterialTempleteDataList[response.itemIndex], 'edit_price_flag', 'true');
        } else {
          // 変更不可
          this.$set(this.partsListData[response.itemIndex], 'edit_price_flag', 'false');
          this.$set(this.RegistMaterialTempleteDataList[response.itemIndex], 'edit_price_flag', 'false');
        }
        break;
      }
      case "edit_material_flag": {
        if (response.record.edit_material_flag !== '') {
          // 編集可
          this.$set(this.partsListData[response.itemIndex], 'edit_material_flag', '');
          this.$set(this.RegistMaterialTempleteDataList[response.itemIndex], 'edit_material_flag', 'true');
        } else {
          // 編集不可
          this.$set(this.partsListData[response.itemIndex], 'edit_material_flag', 'false');
          this.$set(this.RegistMaterialTempleteDataList[response.itemIndex], 'edit_material_flag', 'false');
        }
        break;
      }
    }
  }

  /**
   * アクションパネルのボタンを押下した際の次処理を進める
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private async execAction(type: string) {
    //
    switch (type) {
      case 'cancel': {
        this.$router.go(0);
        break;
      }
      case 'exec': {
        try {
          // ローディングをセット
          this.$store.commit('hexabase/setIsLoading', true);

          // 明細を関連データ部にセット
          const reglistSetter = await this.addRelatedDsItem_Update(
            this.RegistMaterialTempleteDataList,
            this.DeleteMaterialTempleteDataList
          );
          this.$set(this.registData.related_ds_items, this.subDsId, reglistSetter);

          const response =
            this.buttonCrudType !== '4'
              ? await this.materialTemplate.execStatusAction(
                  this.registData,
                  this.projectId,
                  this.mainDsId,
                  this.subDsId,
                  this.itemId,
                  this.execAllowActions,
                  this.execAllowActionsByDetail,
                  this.revNumber,
                  this.selectAction
                )
              : await this.materialTemplate.registerLinkedItems(
                  this.projectId,
                  this.mainDsId,
                  this.registData
                );

          // モーダル内のメッセージ変更
          this.buttonText = response.text || this.buttonText;

          if (this.buttonCrudType === '4') {
            this.buttonText = `「${this.buttonActionName}」を実行しました`;
            this.materialTemplate.apiErrorHandle('CREATEITEM', response);
            this.buttons.splice(0);
            this.buttons.push({
              id: 1,
              type: 'routing',
              color: 'primary',
              value: '詳細画面へ',
              route: `/materialtemplate/edit/${response.item_id}`
            });
          }

          if (this.buttonActionName === '削除する') {
            this.buttons.splice(0);
            this.buttons.push({ id: 1, type: 'back', color: 'primary', value: '前画面へ戻る' });
          }

          break;
        } catch (e) {
          console.log(e);
          this.buttonText = 'エラーにより処理できませんでした';
          this.buttons.splice(0);
          this.buttons.push({ id: 1, type: 'cancel', name: 'cancel', value: '閉じる' });
        } finally {
          this.$store.commit('hexabase/setIsLoading', false);
          this.dialogStatus = true;
        }
        break;
      }
      default:
        break;
    }
  }

  /**
   * 関連データの整形
   * @param {Array<RegistMaterialTempleteData>} - 登録データ
   */
  private async addRelatedDsItem_Update(
    regList: Array<RegistMaterialTempleteData>,
    DelList: Array<RegistMaterialTempleteData>
  ) {
    const retunArray: any = [];
    // 先行して削除レコードの登録を行う
    if (DelList.length > 0) {
      DelList.forEach(delElements => {
        retunArray.push({
          operation: 3,
          i_id: delElements.i_id
        });
      });
    }
    // 更新・追加を行う
    if (regList.length > 0) {
      regList.forEach(regElements => {
        const RegistMaterialTempleteitem: RegistMaterialTempleteExec = {
          materialtemplate_id: this.itemId,
          material_id: regElements.material_id,
          quantity: regElements.quantity,
          quantity_lower_limit: regElements.quantity_lower_limit,
          quantity_upper_limit: regElements.quantity_upper_limit,
          unit_lower_limit: regElements.unit_lower_limit,
          unit_upper_limit: regElements.unit_upper_limit,
          ref_rev_no: regElements.refrev_no,
          ref_item: regElements.refitem,
          ref_item_code: regElements.refitem_code,
          ref_model_number: regElements.refmodel_number,
          sort_no: regElements.No,
          edit_price_flag: regElements.edit_price_flag,
          edit_material_flag: regElements.edit_material_flag
        };
        // リセットされたレコードはidが0でセットされるので当該値で判定する
        if (regElements.id !== 0) {
          // 更新モード
          retunArray.push({
            operation: 2,
            link_to_parent: true,
            i_id: regElements.i_id,
            item: RegistMaterialTempleteitem,
            rev_no: regElements.rev_no
          });
        } else {
          // 追加モード
          retunArray.push({
            operation: 1,
            link_to_parent: true,
            item: RegistMaterialTempleteitem
          });
        }
      });
    }
    return retunArray;
  }

  /*******************************************************************************/

  /**
   * ルーター設定ファイルよりパンくずリスト取得
   * @module getBreadCrumbs
   * @return {array} - breadcrumbs 情報
   */
  private getBreadCrumbs(): [] {
    if (this.$route.matched.some(obj => obj.meta.breadcrumbs)) {
      return this.$route.meta.breadcrumbs;
    }
    return [];
  }

  /**
   * 子コンポーネントからEmitされる値インサート用に加工（基本情報）
   * 主にPropsの変更を行う
   * @module catchInputBasic
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void}
   */
  private catchInputBasic(response: any) {
    const index = this.basicFieldsData.findIndex(v => v.display_id === response.name);
    switch (this.basicFieldsData[index].component) {
      case 'MasterSelectControl':
      case 'MasterSelectSetControl':
      case 'MasterSelectMultiControl':
      case 'MasterSelectMultiSetControl':
        this.$set(this.basicFieldsData[index].props!, 'value', { item_id: response.value });
        break;
      default:
        this.$set(this.basicFieldsData[index].props!, 'value', response.value);
    }
  }

  /**
   * 基本情報パネルで入力された値を受け取り登録データに渡す
   * @public response - インサート用に整形されたデータ
   * @returns void
   */
  private createBasicData(response: any): void {
    this.registData.item = response;
  }

  /**
   * ヘッダ情報フィールド定義作成
   */
  private async getHeaderFields(formData: any) {
    const baseData = {
      cols: {},
      datas: {} as { [k: string]: any }
    };
    try {
      baseData.cols = this.materialTemplate.getGridStatus(formData);
      baseData.datas = formData;
    } catch (errorMessage) {
      this.setError(errorMessage);
    }
    return baseData;
  }

  /**
   * ヘッダ情報フィールドデータ作成
   */
  private getHeaderData(setData: { [key: string]: any }, baseData: any) {
    try {
      Object.keys(setData).map((key: string) => {
        baseData.datas[key].props['value'] = setData[key];
      });
    } catch (errorMessage) {
      this.setError(errorMessage);
    }
  }

  /**
   * フィールド情報を取得して、指定の場所に設定する
   * @module setHeaderListColumn
   */
  private setHeaderListColumn(
    inputFields: any,
    baseListColumn: any,
    setItem: any,
    setArea: string,
    exceptionColumnItem: Array<string> = []
  ) {
    const listColumn = JSON.parse(JSON.stringify(baseListColumn));
    // header内容の書き換え
    this.listHeaderCreate(inputFields, listColumn, exceptionColumnItem);
    this.$set(setItem, setArea, listColumn);
  }

  /**
   * フィールド情報とカラム情報を突き合わせて、不要なカラムを削除
   * @module listHeaderCreate
   */
  private listHeaderCreate(
    listInputField: any,
    listColumn: any,
    exceptionColumnItem: Array<string> = []
  ) {
    const noHeaderName: any = [];
    for (const index in listColumn) {
      const searchItem: any = listColumn[index];
      let setHeaderItem: any;
      Object.keys(listInputField.fields).forEach(key => {
        // 振替・仕入単位の項目がある場合に合計となる振替・仕入金額(参照用も含む)、、営業利益、利益率を表示する為、
        // 例外リスト表示項目を追加する際に追加済のチェックを行い、存在しない場合は追加する
        if ('transfer_unit_price' === listInputField.fields[key].display_id) {
          if (!exceptionColumnItem.includes('reference_transfer_unit_price')) {
            exceptionColumnItem.push('reference_transfer_unit_price');
          }
          if (!exceptionColumnItem.includes('transfer_amount_price')) {
            exceptionColumnItem.push('transfer_amount_price');
          }
          if (!exceptionColumnItem.includes('operating_income')) {
            exceptionColumnItem.push('operating_income');
          }
          if (!exceptionColumnItem.includes('profit_rate')) {
            exceptionColumnItem.push('profit_rate');
          }
        } else if ('purchase_unit_price' === listInputField.fields[key].display_id) {
          if (!exceptionColumnItem.includes('reference_purchase_unit_price')) {
            exceptionColumnItem.push('reference_purchase_unit_price');
          }
          if (!exceptionColumnItem.includes('purchasing_price')) {
            exceptionColumnItem.push('purchasing_price');
          }
          if (!exceptionColumnItem.includes('operating_income')) {
            exceptionColumnItem.push('operating_income');
          }
          if (!exceptionColumnItem.includes('profit_rate')) {
            exceptionColumnItem.push('profit_rate');
          }
        }

        if (listInputField.fields[key].display_id === listColumn[index].value) {
          setHeaderItem = listColumn[index];
          return;
        }
      });

      if (setHeaderItem === undefined) {
        // トランやマスタに入っていない
        const exceptionItem = exceptionColumnItem.find(function(item) {
          if (searchItem.value === item) {
            return item;
          }
        });

        if (exceptionItem === undefined) {
          noHeaderName.push(listColumn[index].value);
        }
      }
    }
    for (const index in noHeaderName) {
      const searchIndex = listColumn.findIndex(function(item: any) {
        if (item.value === noHeaderName[index]) {
          return item;
        }
      });
      if (searchIndex !== -1) {
        listColumn.splice(searchIndex, 1);
      }
    }
  }

  /**
   * 前画面に戻る
   */
  private movePrevious() {
    this.$router.back();
  }

  /**
   * アイテムを登録後ダイアログ表示等を初期化します
   * @returns {void} - 内部プロパティ変更
   */
  private registerFinish(): void {
    this.dialogStatus = false;
    this.isLoading = false;
  }

  /**
   * エラー情報の処理
   * @param {string} - エラー情報文字列
   */
  private setError(errorMessage: any) {
    if (typeof errorMessage === 'object')
      errorMessage = this.materialTemplate.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }
}
